// fork(oem): IBM Plex Mono for IDs / meters / money — pairs with the
// `font-mono` mapping in tailwind.config.js and the `.mono` recipe in oem.css.
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import './styles/tokens.css';
import './styles/brands.css'; // fork(oem): per-client accent families (after tokens)
import './styles/oem.css'; // fork(oem): condition bands, status semantics, .mono
import { Router } from './app/router';
import { CommentProvider } from './comments/CommentContext';
import { CommentOverlay } from './comments/CommentOverlay';
import { CommentIntro } from './comments/CommentIntro';
import { RoleProvider } from './shared/RoleContext';
import { AIRailScopeProvider } from './shared/AIRailScopeContext';
import { ChatProvider } from './shared/ChatContext';
import { SidebarStateProvider } from './shared/SidebarStateContext';
import { BrandProvider } from './shared/BrandContext'; // fork(oem)
import { DemoModeProvider } from './shared/DemoModeContext'; // fork(oem)
import { OemPersonaProvider } from './shared/OemPersonaContext'; // fork(oem)
import { ToastProvider } from './shared/toast/ToastContext'; // fork(oem)

export default function V1App() {
  return (
    <CommentProvider version="v1">
      {/* fork(oem): DemoModeProvider → BrandProvider → ToastProvider →
          OemPersonaProvider sit above RoleProvider. Order matters:
          OemPersonaProvider raises a toast and syncs the foundation persona on
          switch, so it needs both below it. DemoModeProvider is outermost and
          depends on nothing — the rail and the settings cards both read it. */}
      <DemoModeProvider>
        <BrandProvider>
          <ToastProvider>
            <OemPersonaProvider>
              <RoleProvider>
                <SidebarStateProvider>
                  <ChatProvider>
                    <AIRailScopeProvider>
                      <Router />
                      <CommentOverlay />
                      <CommentIntro />
                    </AIRailScopeProvider>
                  </ChatProvider>
                </SidebarStateProvider>
              </RoleProvider>
            </OemPersonaProvider>
          </ToastProvider>
        </BrandProvider>
      </DemoModeProvider>
    </CommentProvider>
  );
}
